// src/pages/Dashboard/Finance/Payroll/TotalProfit.jsx
import React from "react";
import { Grid, Paper, Box, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { useTranslation } from "react-i18next";

const TotalProfit = ({ summaryData = {} }) => {
  const { t } = useTranslation();
  const data = [
    { name: t("finance.totalIncome"), value: Number(summaryData.total_income) || 0 },
    { name: t("finance.totalExpenses"), value: Number(summaryData.total_expenses) || 0 },
    { name: t("finance.netIncome"), value: Number(summaryData.net_income) || 0 },
  ];

  return (
    <Grid container>
      <Paper sx={{ width: "100%", padding: 3, borderRadius: 2, boxShadow: 3 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {t("finance.profitSummary")}
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.3} />
            <XAxis dataKey="name" tick={{ fill: "#555", fontWeight: "bold" }} />
            <YAxis tick={{ fill: "#555", fontWeight: "bold" }} />
            <Tooltip cursor={{ fill: "rgba(200,200,200,0.3)" }} />
            <Legend verticalAlign="top" align="right" iconType="circle" />
            <Bar dataKey="value" fill="#1976d2" barSize={30} radius={[4, 4, 0, 0]} name={t("finance.value")} />
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default TotalProfit;
